<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <div class="row mt-5">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">Seminar Content</h4>
                    </div>
                    <div class="card-body">
                        <form class="forms-sample" enctype="multipart/form-data" method="post" @submit.stop.prevent="updateHomeContent"
                            autocomplete="off">
                            <div class="row mt-5">
                                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                                    <div class="row flex-grow">
                                        <div class="col-12">
                                            <div class="">
                                                <div class="">
                                                    <div class="row">
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginSeminarsText1" class="d-inline-block">Seminars Text 1
                                                                </label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginSeminarsText1Status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginSeminarsText1Status', homeContentData.PreLoginSeminarsText1Status)">
                                                                    {{ homeContentData.PreLoginSeminarsText1Status == 1 ? "hide" : 'show'
                                                                    }} </button>
                                                                <div style="width: 100%; overflow: auto;">
                                                                    <ckeditor id="PreLoginSeminarsText1"
                                                                        v-model="homeContentData.PreLoginSeminarsText1" :config="editorConfig">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginSeminarsText1.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <!-- <b-form-group label="Seminars Text 2" class="d-inline-block" label-for="PreLoginSeminarsText2"> -->
                                                            <b-form-group >
                                                                <label for="PreLoginSeminarsText2" class="d-inline-block">Seminars Text 2
                                                                </label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginSeminarsText2Status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginSeminarsText2Status', homeContentData.PreLoginSeminarsText2Status)">
                                                                    {{ homeContentData.PreLoginSeminarsText2Status == 1 ? "hide" : 'show'
                                                                    }} </button>
                                                                <b-form-input type="text" id="PreLoginSeminarsText2"
                                                                    :state="$v.homeContentData.PreLoginSeminarsText2.$dirty ? !$v.homeContentData.PreLoginSeminarsText2.$error : null"
                                                                    v-model="homeContentData.PreLoginSeminarsText2"
                                                                    name="PreLoginSeminarsText2" autocomplete="PreLoginSeminarsText2"
                                                                    placeholder="Seminars Text 2">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback>This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>

                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginSeminarsText3" class="d-inline-block">Seminars Text
                                                                    3</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginSeminarsText3Status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginSeminarsText3Status', homeContentData.PreLoginSeminarsText3Status)">
                                                                    {{ homeContentData.PreLoginSeminarsText3Status == 1 ? "hide" : 'show'
                                                                    }} </button>
                                                                <div style="width: 100%; overflow: auto">
                                                                    <ckeditor id="PreLoginSeminarsText3"
                                                                        v-model="homeContentData.PreLoginSeminarsText3" :config="editorConfig1">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginSeminarsText3.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginSeminarsText5" class="d-inline-block">Seminar will
                                                                    Last</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginSeminarsText5Status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginSeminarsText5Status', homeContentData.PreLoginSeminarsText5Status)">
                                                                    {{ homeContentData.PreLoginSeminarsText5Status == 1 ? "hide" : 'show'
                                                                    }} </button>
                                                                <div style="width: 100%; overflow: auto">
                                                                    <ckeditor id="PreLoginSeminarsText5"
                                                                        v-model="homeContentData.PreLoginSeminarsText5" :config="editorConfig2">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginSeminarsText5.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginRegistrationText8" class="d-inline-block">Registration
                                                                    begin</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginRegistrationText8Status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginRegistrationText8Status', homeContentData.PreLoginRegistrationText8Status)">
                                                                    {{ homeContentData.PreLoginRegistrationText8Status == 1
                                                                        ? "hide" : 'show' }} </button>
                                                                <div style="width: 100%; overflow: auto">
                                                                    <ckeditor id="PreLoginRegistrationText8"
                                                                        v-model="homeContentData.PreLoginRegistrationText8" :config="editorConfig3">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginRegistrationText8.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">

                                                            <div role="group" class="form-group">
                                                                <label for="PreLoginSeminarsText6" class="d-inline-block">Registration</label>
                                                                <button
                                                                    :class="`btn ${homeContentData.PreLoginSeminarsText6Status == 1 ? 'btn-danger' : 'btn-primary'} btn-sm d-inline-block float-right`"
                                                                    @click.prevent="activeDeactiveContent('PreLoginSeminarsText6Status', homeContentData.PreLoginSeminarsText6Status)">
                                                                    {{ homeContentData.PreLoginSeminarsText6Status == 1 ? "hide" : 'show'
                                                                    }} </button>

                                                                <div style="width: 100%; overflow: auto">
                                                                    <ckeditor id="PreLoginSeminarsText6"
                                                                        v-model="homeContentData.PreLoginSeminarsText6" :config="editorConfig4">
                                                                    </ckeditor>
                                                                </div>
                                                                <div v-if="$v.homeContentData.PreLoginSeminarsText6.$error"
                                                                    class=" text-danger error-message">
                                                                    This is a required field.
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <b-form-group
                                                                label="Home Page Image uploading Path (Image will be save in the dctrainings3/dctwebsite)"
                                                                label-for="uploadingPath">
                                                                <b-form-input type="text" id="uploadingPath"
                                                                    v-model="contentConfig.uploadingPath" name="uploadingPath"
                                                                    :state="$v.contentConfig.uploadingPath.$dirty ? !$v.contentConfig.uploadingPath.$error : null"
                                                                    placeholder="Home Page Image uploading Path (Image will be save in the dctrainings3/dctwebsite)">
                                                                </b-form-input>
                                                                <b-form-invalid-feedback id="input-1-live-feedback">This is a required
                                                                    field.
                                                                </b-form-invalid-feedback>
                                                            </b-form-group>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 1"
                                                                        label-for="PreLoginSeminarsImage1">
                                                                        <b-form-file id="PreLoginSeminarsImage1"
                                                                            v-model="contentImages.PreLoginSeminarsImage1"
                                                                            name="PreLoginSeminarsImage1" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image">

                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginSeminarsImage1}`"
                                                                        class=" img-fluid" alt="" width="200">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 2"
                                                                        label-for="PreLoginSeminarsImage2">

                                                                        <b-form-file id="PreLoginSeminarsImage2"
                                                                            v-model="contentImages.PreLoginSeminarsImage2"
                                                                            name="PreLoginSeminarsImage2" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image">
                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginSeminarsImage2}`"
                                                                        class=" img-fluid" alt="" width="200">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 3"
                                                                        label-for="PreLoginSeminarsImage3">

                                                                        <b-form-file id="PreLoginSeminarsImage3"
                                                                            v-model="contentImages.PreLoginSeminarsImage3"
                                                                            name="PreLoginSeminarsImage3" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image">
                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginSeminarsImage3}`"
                                                                        class=" img-fluid" alt="" width="200">
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 4"
                                                                        label-for="PreLoginSeminarsImage4">
                                                                        <b-form-file id="PreLoginSeminarsImage4"
                                                                            v-model="contentImages.PreLoginSeminarsImage4"
                                                                            name="PreLoginSeminarsImage4" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image"
                                                                            :state="!contentImages.PreLoginSeminarsImage4">
                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginSeminarsImage4}`"
                                                                        class=" img-fluid" alt="" width="200">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 5"
                                                                        label-for="PreLoginSeminarsImage5">
                                                                        <b-form-file id="PreLoginSeminarsImage5"
                                                                            v-model="contentImages.PreLoginSeminarsImage5"
                                                                            name="PreLoginSeminarsImage5" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image"
                                                                            :state="!contentImages.PreLoginSeminarsImage5">
                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginSeminarsImage5}`"
                                                                        class=" img-fluid" alt="" width="200">
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-md-12">
                                                            <div class="row">
                                                                <div class="col-md-7">

                                                                    <b-form-group label="Home Page Image 6"
                                                                        label-for="PreLoginSeminarsImage6">
                                                                        <b-form-file id="PreLoginSeminarsImage6"
                                                                            v-model="contentImages.PreLoginSeminarsImage6"
                                                                            name="PreLoginSeminarsImage6" accept=".jpg, .jpeg, .png"
                                                                            placeholder="Choose an image"
                                                                            :state="!contentImages.PreLoginSeminarsImage6">
                                                                        </b-form-file>
                                                                    </b-form-group>
                                                                </div>
                                                                <div class="col-md-5">
                                                                    <img :src="`${$server_url}${homeContentData.PreLoginSeminarsImage6}`"
                                                                        class=" img-fluid" alt="" width="200">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6"></div>
                                                        <div class="col-md-6 mt-3">
                                                            <b-button type="submit" variant="success"
                                                                class="btn float-right btn-success">
                                                                Submit
                                                            </b-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import Snotify, { SnotifyPosition } from 'vue-snotify'
import CKEditor from 'ckeditor4-vue';

const options = {
    toast: {
        position: SnotifyPosition.rightTop,
    }
}
Vue.use(Snotify, options)
Vue.use(CKEditor);

export default {
    name: "seminar_content",
    mixins: [validationMixin],
    data() {
        return {
            contentImages: {
                PreLoginSeminarsImage1: [],
                PreLoginSeminarsImage2: [],
                PreLoginSeminarsImage3: [],
                PreLoginSeminarsImage4: [],
                PreLoginSeminarsImage5: [],
                PreLoginSeminarsImage6: []
            },
            contentConfig: {
                uploadingPath: "images/Content Images/Seminar Page"
            },
            homeContentData: {
                PreLoginSeminarsText2: "",
                PreLoginSeminarsText1: "",
                PreLoginSeminarsText3: "",
                PreLoginSeminarsText5: "",
                PreLoginRegistrationText8: "",
                PreLoginSeminarsText6: "",
                PreLoginSeminarsImage1: '',
                PreLoginSeminarsImage2: '',
                PreLoginSeminarsImage3: '',
                PreLoginSeminarsImage4: '',
                PreLoginSeminarsImage5: "",
                PreLoginSeminarsImage6: "",
                PreLoginSeminarsText1Status: null
            },
            editorConfig: { 
                versionCheck: false 
            },
            editorConfig1: { 
                versionCheck: false 
            },
            editorConfig2: { 
                versionCheck: false 
            },
            editorConfig3: { 
                versionCheck: false 
            },
            editorConfig4: { 
                versionCheck: false 
            }
        }
    },
    validations: {
        homeContentData: {
            PreLoginSeminarsText2: {
                required
            },
            PreLoginSeminarsText1: {
                required
            },
            PreLoginSeminarsText3: {
                required
            },
            PreLoginSeminarsText5: {
                required
            },
            PreLoginRegistrationText8: {
                required
            },
            PreLoginSeminarsText6: {
                required
            },

        },
        contentConfig: {
            uploadingPath: {
                required
            },
        },
    },
    methods: {
        activeDeactiveContent(field, s) {
            let status = s == true ? 0 : 1;
            this.homeContentData[field] = status;
            API.activeDeactiveContent({ field, status }, this.activeDeactiveContentCB, this.errorCB);
        },
        activeDeactiveContentCB(res) {
            this.$showNotification(res.data, 'success')
        },
        updateHomeContent() {
            this.$v.homeContentData.$touch();
            this.$v.contentConfig.$touch();
            if (this.$v.homeContentData.$anyError || this.$v.contentConfig.$anyError) {
                return;
            }
            API.updateHomeContent({ ...this.homeContentData, ...this.contentConfig, ...this.contentImages }, this.updateHomeContentCB, this.errorCB)
        },
        updateHomeContentCB(res) {
            this.homeContentData = res.data;
            this.$showNotification({message:"Updated Successfully"}, 'success')
        },
        getWebContent() {
            API.getWebContent(this.getWebContentCB, this.errorCB)
        },
        getWebContentCB(res) {
            this.homeContentData = res.data;
            this.$showNotification(res, 'success')
        },
        errorCB(err) {
            console.log(err);
            this.$showNotification({ message: "Failed system error" }, 'error')
        },
    },
    mounted() {
        this.getWebContent();
    },
    components: {}
}
</script>
